import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import FormSubmitButton from '../FormSubmitButton';
import EmailField from '../EmailField';
import { FirstAndLastNameFields } from '../SignUpFields';
import LegalNotice from '../LegalNotice';

import { formValidate } from '@eb/eds-utils';
import { SocialSignUpValidate as validate } from '../utils';

import { SOCIAL_SIGN_UP_FORM } from '../../constants';

class SocialSignUpForm extends React.PureComponent {
    static propTypes = {
        locale: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        buttonCTA: translationPropType,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),

        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitSucceeded: PropTypes.bool,
        submitting: PropTypes.bool,
    };

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    render() {
        const {
            locale,
            handleSubmit,
            buttonCTA,
            submitting,
            submitSucceeded,
            socialSSOSettings,
        } = this.props;

        const buttonClasses =
            'eds-fx--fade-in-down eds-fx--delay-1 eds-l-mar-top-8';

        const submitDisabled = submitting || submitSucceeded;

        const twoStepsSignup =
            socialSSOSettings && socialSSOSettings.twoStepsSignup;

        let privacyPolicy = null;

        if (twoStepsSignup) {
            privacyPolicy = <LegalNotice locale={locale} />;
        }

        return (
            <div className="eds-fx--fade-in eds-fx--delay-2">
                <form onSubmit={handleSubmit} noValidate="novalidate">
                    <EmailField />
                    <FirstAndLastNameFields />
                    <FormSubmitButton
                        submitDisabled={submitDisabled}
                        buttonClasses={buttonClasses}
                        buttonCTA={buttonCTA}
                    />
                    {privacyPolicy}
                </form>
            </div>
        );
    }
}

export default formValidate({
    validate,
    form: SOCIAL_SIGN_UP_FORM,
    touchOnBlur: false,
})(SocialSignUpForm);
